import type { PostPlaceAbsenteeBidResponse } from '@/redux/api/bid';
import type { TypedActionWithPayload } from '@/types/redux';

export const ABSENTEE_BID_FAILURE = 'la/ui/absenteeBid/FAILURE';
export type ABSENTEE_BID_FAILURE_ACTION = TypedActionWithPayload<typeof ABSENTEE_BID_FAILURE, string>;

export const ABSENTEE_BID_REQUEST = 'la/ui/absenteeBid/REQUEST';
export type ABSENTEE_BID_REQUEST_ACTION = TypedActionWithPayload<typeof ABSENTEE_BID_REQUEST>;

export const ABSENTEE_BID_SUCCESS = 'la/ui/absenteeBid/SUCCESS';
export type ABSENTEE_BID_SUCCESS_ACTION = TypedActionWithPayload<
    typeof ABSENTEE_BID_SUCCESS,
    PostPlaceAbsenteeBidResponse,
    {
        actionTime: number;
        analytics: any;
        itemId: number;
    }
>;
